import { UploadOutlined } from "@ant-design/icons";
import { Alert, Button, Card, Col, message, Row, Typography, Upload } from "antd";
import React, { useState } from "react";
import { authAxios } from "../utils/session_utils";

const { Title } = Typography;

const BTT_Uploader = () => {
	const [fileList, setFileList] = useState<any[]>([]);
	const [loading, setLoading] = useState<boolean>(false);

	const handleBeforeUpload = (file: File) => {
		const isCSV = file.type === "text/csv" || file.name.endsWith(".csv");
		if (!isCSV) {
			message.error("Only CSV files are allowed!");
			return Upload.LIST_IGNORE;
		}

		setFileList([
			{
				originFileObj: file,
				name: file.name,
				status: "done",
			},
		]);

		return false;
	};

	const handleOnChange = (info: any) => {
		setFileList(info.fileList);
	};

	const handleUpload = async () => {
		if (!fileList.length) {
			message.error("No file selected");
			return;
		}

		setLoading(true);
		const hideLoading = message.loading("Uploading CSV...", 0);

		try {
			// Create a FormData object to send the file
			const formData = new FormData();
			formData.append("file", fileList[0].originFileObj);

			// Use authAxios instead of fetch
			const config = {
				method: "POST",
				url: `${process.env.REACT_APP_BACK_END_API}/salesforce/btt_uploader`,
				data: formData,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			const response = await authAxios(config);

			if (!response?.data?.success) {
				throw new Error(response?.data?.error || "Failed to upload CSV.");
			}

			message.success(`CSV uploaded successfully`);

			setLoading(false);
			setFileList([]);
			hideLoading();
		} catch (error: any) {
			console.error("Upload error:", error);
			setLoading(false);
			hideLoading();
			message.error(`Upload failed: ${error.message || "Unknown error"}`);
		}
	};
	return (
		<Card
			title={<Title level={4}>BTT Uploader</Title>}
			style={{ maxWidth: 900, margin: "20px auto", boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)" }}
			bordered={true}
		>
			<Row gutter={[16, 16]}>
				<Col span={24}>
					<Upload
						beforeUpload={handleBeforeUpload}
						onChange={handleOnChange}
						fileList={fileList}
						maxCount={1}
						onRemove={() => setFileList([])}
					>
						<Button icon={<UploadOutlined />} disabled={loading} size="large">
							Select File
						</Button>
					</Upload>
				</Col>
			</Row>
			{fileList.length > 0 && (
				<Row style={{ marginTop: 16 }}>
					<Col span={24}>
						<Alert
							message="File Selected"
							description={`File "${fileList[0].name}" is ready to upload.`}
							type="info"
							showIcon
						/>
					</Col>
				</Row>
			)}

			<Row gutter={[16, 16]} style={{ marginTop: 16 }}>
				<Col span={24}>
					<Button
						type="primary"
						onClick={handleUpload}
						disabled={!fileList.length || loading}
						loading={loading}
						size="large"
						block
					>
						{loading ? "Uploading..." : "Upload"}
					</Button>
				</Col>
			</Row>
		</Card>
	);
};

export default BTT_Uploader;
